/* Kundenfragen (sections/sk-product-questions.liquid) – ausgelagert 30.10.2026 (mottenspray-perfekt).
   Konfiguration je Section in <script type="application/json" data-sk-pq-config="<section-id>">. */
(function () {
  function init(cfgEl) {
    if (cfgEl.__skPq) return; cfgEl.__skPq = 1;
    var C; try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var root = document.getElementById('sk-pq-' + cfgEl.getAttribute('data-sk-pq-config'));
    if (!root) return;

    
    var ENDPOINT = C.endpoint;
    var T = C.t;
    var toggle = root.querySelector('[data-pq-toggle]');
    var wrap = root.querySelector('.sk-pq__form-wrap');
    var form = root.querySelector('[data-pq-form]');
    var errBox = root.querySelector('[data-pq-error]');
    var success = root.querySelector('[data-pq-success]');
    var submitBtn = root.querySelector('[data-pq-submit]');

    function setOpen(open) {
      wrap.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var ta = form.querySelector('textarea');
        if (ta && !form.hidden) ta.focus();
      }
    }
    toggle.addEventListener('click', function() { setOpen(wrap.hidden); });
    root.querySelector('[data-pq-cancel]').addEventListener('click', function() { setOpen(false); });

    function showError(msg) { errBox.textContent = msg; errBox.hidden = false; }

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      errBox.hidden = true;
      var fd = new FormData(form);
      var question = String(fd.get('question') || '').trim();
      var email = String(fd.get('email') || '').trim();
      if (question.length < 10) { showError(T.errShort); return; }
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError(T.errEmail); return; }
      var payload = {
        productId: C.productId,
        productHandle: C.productHandle,
        productTitle: C.productTitle,
        question: question,
        email: email,
        name: String(fd.get('name') || '').trim(),
        location: String(fd.get('location') || '').trim(),
        showName: fd.get('show_name') === '1',
        locale: C.locale,
        pageUrl: location.origin + location.pathname,
        website: String(fd.get('website') || '')
      };
      submitBtn.disabled = true;
      submitBtn.textContent = T.sending;
      fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        mode: 'cors'
      }).then(function(r) {
        if (!r.ok) throw new Error(String(r.status));
        form.hidden = true;
        success.hidden = false;
        toggle.hidden = true;
      }).catch(function(err) {
        var code = (err && err.message && /^\d+$/.test(err.message)) ? err.message : 'network';
        showError(T.errGeneric.replace('[code]', code));
      }).then(function() {
        submitBtn.disabled = false;
        submitBtn.textContent = T.submit;
      });
    });

    function expand() {
      var t = root.querySelector('template[data-pq-extra-tpl]');
      if (t && t.parentNode) t.parentNode.replaceChild(t.content, t);
    }
    var more = root.querySelector('[data-pq-more]');
    if (more) {
      more.addEventListener('click', function() {
        expand();
        root.querySelectorAll('[data-pq-extra]').forEach(function(el) { el.hidden = false; el.removeAttribute('data-pq-extra'); });
        more.hidden = true;
      });
    }

    var search = root.querySelector('[data-pq-search]');
    if (search) {
      var items = root.querySelectorAll('[data-pq-item]');
      var noRes = root.querySelector('[data-pq-no-results]');
      search.addEventListener('input', function() {
        if (root.querySelector('template[data-pq-extra-tpl]')) { expand(); items = root.querySelectorAll('[data-pq-item]'); }
        var term = search.value.trim().toLowerCase();
        var shown = 0;
        if (more && term) more.hidden = true;
        items.forEach(function(el) {
          if (!term) {
            el.hidden = el.hasAttribute('data-pq-extra');
          } else {
            el.hidden = el.textContent.toLowerCase().indexOf(term) === -1;
          }
          if (!el.hidden) shown++;
        });
        if (more && !term && root.querySelector('[data-pq-extra]')) more.hidden = false;
        noRes.hidden = shown > 0;
      });
    }
  
  }
  function run() { document.querySelectorAll('script[data-sk-pq-config]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
